const SearchableDropdownComponent = {
	template: require('./searchable-dropdown.html'),
	require: {
		ngModel: '?ngModel'
	},
	bindings: {
		displayAttr: '@',
		items: '<',
		onSelectionChanged: '&',
		selectedItem: '<?'
	},
	controller: function() {
		var vm = this;
		vm.searchQuery = '';

		vm.updateSelectedItem = function(obj) {
			if (obj) {
				vm.selectedItem = obj;
				vm.onSelectionChanged({ selectedPackage: vm.selectedItem });
			} else {
				vm.selectedItem = null;
			}

			if (vm.ngModel) {
				vm.ngModel.$setValidity(
					'required',
					vm.selectedItem && vm.selectedItem.id
				);
			}
		};
	},
	controllerAs: 'vm'
};

export default SearchableDropdownComponent;
